import React, { useMemo, useCallback, useContext } from 'react';
import AttributeSortingList from './AttributeSortingList';
import { IterationContext } from '../../contexts/IterationContext';

type AttributeSortingProps = {
    categoryData: CategoryData;
    onCategoryDataChange: (updatedData: CategoryData) => void;
};

export const AttributeSorting: React.FC<AttributeSortingProps> = ({
    categoryData,
    onCategoryDataChange,
}) => {

    const { attributeList } = useContext(IterationContext);

    const allAttributeOptions = useMemo(() => {
        const list = attributeList?.map(attribute => ({
            id: attribute.value,
            name: attribute.label,
        })) || [];
        return list
    }, [attributeList]);

    const handleSortingChange = useCallback((iterationId: string, attributeSorting: AttributeSortItem[]) => {
        const updatedIterations = categoryData.iterations.map(iteration =>
            iteration.id === iterationId ? { ...iteration, attribute_sorting: attributeSorting } : iteration
        );

        const updatedCategoryData = {
            ...categoryData,
            iterations: updatedIterations,
        };

        onCategoryDataChange(updatedCategoryData);
    }, [categoryData, onCategoryDataChange]);

    return (
        <div className="tw-w-full" data-testid="attribute-sorting-container">
            {categoryData.iterations.map((iteration: Iteration) => (
                <div key={iteration.id} className="tw-pb-6 tw-border-b tw-border-edge">
                    <AttributeSortingList
                        iteration={iteration}
                        attributeOptions={allAttributeOptions}
                        onSortingChange={handleSortingChange}
                    />
                </div>
            ))}
        </div>
    );
};

export default AttributeSorting;